
import React from "react";
import { Helmet } from "react-helmet-async";

const AdminAnalytics: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Analytics - Admin Dashboard</title>
      </Helmet>
      <div className="p-6">
        <h1 className="text-3xl font-bold mb-6">Analytics Dashboard</h1>
        <p className="text-muted-foreground">Platform analytics and metrics.</p>
      </div>
    </>
  );
};

export default AdminAnalytics;
